import AssignmentTurnedInOutlinedIcon from '@mui/icons-material/AssignmentTurnedInOutlined';
import BarChartOutlinedIcon from '@mui/icons-material/BarChartOutlined';
import CompareIcon from '@mui/icons-material/Compare';
import InsightsIcon from '@mui/icons-material/Insights';
import InventoryOutlinedIcon from '@mui/icons-material/InventoryOutlined';
import MonitorHeartOutlinedIcon from '@mui/icons-material/MonitorHeartOutlined';
import NotificationsOutlinedIcon from '@mui/icons-material/NotificationsOutlined';
import QueryStatsIcon from '@mui/icons-material/QueryStats';
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import AutoModeIcon from '@mui/icons-material/AutoMode';
import ChatIcon from '@mui/icons-material/Chat';

import SmartToyOutlinedIcon from '@mui/icons-material/SmartToyOutlined';

import i18n from '../locales/i18n';

import { paths } from './paths';

const navbarIcons = {
  search: SearchOutlinedIcon,
  validation: AssignmentTurnedInOutlinedIcon,
  evaluation: InventoryOutlinedIcon,
  crawler: MonitorHeartOutlinedIcon,
  benchmarking: CompareIcon,
  analysis: BarChartOutlinedIcon,
  notifications: NotificationsOutlinedIcon,
  research: InsightsIcon,
  statistics: QueryStatsIcon,
  settings: SettingsOutlinedIcon,
  marketIntelligence: AutoModeIcon,
  itSupport: ChatIcon,
  aiUpload: SmartToyOutlinedIcon,
};

export const navbarItems = [
  {
    text: i18n.t('navbar.companySearch'),
    path: paths.search,
    icon: navbarIcons.search,
  },
  {
    text: i18n.t('navbar.validation'),
    path: paths.crawlerInbox,
    icon: navbarIcons.validation,
  },
  {
    text: i18n.t('navbar.evaluation'),
    icon: navbarIcons.evaluation,
    path: paths.evaluation.evaluation,
    subItems: [
      { text: i18n.t('navbar.assessment'), path: paths.evaluation.dfm },
      { text: i18n.t('navbar.techAssessment'), path: paths.evaluation.techAssessment },
      {
        text: i18n.t('navbar.customerSegment'),
        path: paths.evaluation.customerSegment,
      },
      { text: i18n.t('navbar.companyFiles'), path: paths.evaluation.companyFiles },
      { text: 'Buy & Build', path: paths.evaluation.bbLists },
      { text: 'Market Research', path: paths.evaluation.marketResearch },
      { text: 'AI Threat Index', path: paths.evaluation.aiThreatIndex },
      { text: 'YC Startups', path: paths.evaluation.startups },
      { text: 'DD Findings', path: paths.evaluation.companyAnnotations },
      { text: i18n.t('navbar.outreach'), path: paths.evaluation.outreach },
    ],
  },
  {
    text: 'Deal Assessment',
    path: paths.aiUpload,
    icon: navbarIcons.benchmarking,
    subItems: [
      { text: 'Deal Assessment AI', path: paths.aiUpload },
      { text: 'Legacy Upload', path: paths.benchmarking },
    ],
  },
  {
    text: i18n.t('navbar.marketIntelligence'),
    path: paths.dealAnnouncements,
    icon: navbarIcons.marketIntelligence,
    subItems: [
      { text: i18n.t('navbar.dealAnnouncements'), path: paths.dealAnnouncements },
      { text: i18n.t('navbar.transactions'), path: paths.transactions },
      { text: i18n.t('navbar.investorsGraph'), path: paths.investorsGraph },
    ],
  },
  {
    text: 'Statistics',
    path: paths.statistics,
    icon: navbarIcons.statistics,
  },
  {
    text: 'Research',
    path: paths.research.valuationModel,
    icon: navbarIcons.research,
    subItems: [
      { text: 'Valuation Model', path: paths.research.valuationModel },
      { text: 'Industry Benchmarks', path: paths.research.industryBenchmarks },
    ],
  },
  {
    text: i18n.t('navbar.crawler-ops'),
    path: paths.crawlerOps.main,
    icon: navbarIcons.crawler,
    subItems: [
      { text: 'Pipedrive', path: paths.crawlerOps.pipedrive },
      { text: 'ML Stats', path: paths.crawlerOps.mlStats },
      { text: 'Signal Tracking', path: paths.crawlerOps.signalTracking },
      { text: 'Crawler Dashboard', path: paths.crawlerOps.dashboard },
      { text: 'Enrichment Performance', path: paths.crawlerOps.enrichmentPerformance },
      { text: 'SW Classifier', path: paths.crawlerOps.swClassifier },
      { text: 'Crawl Queue', path: paths.crawlerOps.crawlQueue },
    ],
  },
  {
    text: i18n.t('navbar.settings'),
    path: paths.settings,
    icon: navbarIcons.settings,
    subItems: [
      { text: 'AI Threat Design', path: paths.aiThreatDesign },
      { text: 'Scheduled Tasks', path: paths.scheduledTasks },
      { text: 'App Insight', path: paths.appInsight },
    ],
  },
];

export const navbarNotificationsItemWithBadge = {
  text: i18n.t('navbar.notifications'),
  path: paths.notifications,
  Icon: navbarIcons.notifications,
  subItems: [
    { text: 'Crawl Activities', path: paths.notifications },
    { text: 'Pipedrive Activity', path: paths.pipedriveActivity },
  ],
};
